import { ReactComponent as CattleMap } from "../../../../assets/svg/icons/cattle.svg";
import { useFilter } from "../../../../hooks/useFilter";
import Constants from "../../../../constants/Index";
import axios from "../../../../services/axios";
import { Dropdown } from "../../../../components/EditOnboarding/components/Select";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import "../styles.css";
import { IBatch } from "../../../../@types/API/IBatches";
import { IAreas } from "../../../../@types/API/IArea";
import { IOptionProps } from "../../../../@types/reactSelect/IOption";
import { ButtonExportPDF } from "../../../../components/Buttons/ButtonExportPDF";
import { ButtonExportExcel } from "../../../../components/Buttons/ButtonExportExcel";
import { exportBatchesDataToExcel } from "../../../../utils/excel/exportBatchesData";
import { sortBy } from "../../../../utils/arrays/sortBy";


export default function DashboardCattleMapBatches() {
  const {
    setHideMicroAreaFilter,
    setHideBatchFilter,
    setDashboard,
    setSideBarOptionSelected,
    farmFilter,
    areasIdsFilter,
    batchCategory,
    setBatchCategory
  } = useFilter();

  const {
    control,
    watch
  } = useForm();

  const [areas, setAreas] = useState<IAreas>();
  const [batches, setBatches] = useState<IBatch[]>();
  const batchesSelected = watch("batches")

  useEffect(() => {
    setHideMicroAreaFilter(true)
    setHideBatchFilter(true)
    setSideBarOptionSelected("DASHBOARD")
    setDashboard("BATCHES")
    document.title = Constants.TITLE_DASHBOARD;
  }, []);

  useEffect(() => {
    if (farmFilter) {
      axios.get(`/areas?farm_id=${farmFilter.id}`).then(response => setAreas(response.data))
      axios.get(`/batches?farm_id=${farmFilter.id}`).then(response => setBatches(response.data))
    }
  }, [farmFilter]);


  useEffect(() => {
    if (farmFilter && areasIdsFilter && areas) {
      const defaultAreas = areas.map(area => area.id)

      axios
        .get(`/batches/categories?farmId=${farmFilter?.id}&${areasIdsFilter.length > 0 ? areasIdsFilter.map(area => `areaIds=${area.value}`).join("&") : defaultAreas.map(area => `areaIds=${area}`).join("&")}&${batchesSelected?.length > 0 ? batchesSelected.map((batch: IOptionProps) => `batchIds=${batch.value}`).join("&") : ""}&size=${999}`)
        .then((response) => {
          const data = response.data;
          if (data && Array.isArray(data.content)) {
            data.content.sort((a: any, b: any) => {
              const keyA = `${a.farm_initials}-${a.area_initials}-${a.initials}`;
              const keyB = `${b.farm_initials}-${b.area_initials}-${b.initials}`;
              return keyA.localeCompare(keyB, undefined, { sensitivity: "base" });
            });
          }
          setBatchCategory(data);
        })
    }
  }, [farmFilter, areasIdsFilter, areas, batchesSelected]);

  return (
    <div className="cattleMap_background" style={{ height: "100vh", overflowY: "auto" }}>
      <form className="dashboardPastureManagement">

        <div className="cattleMap_page">
          <div className="cattleMap_header">
            <CattleMap height={72} />
            <div style={{
              display: "flex",
              flexDirection: "column",
            }}>
              <h2 className="cattleMap_title">
                Mapa de Gado
              </h2>
              <h3 className="cattleMap_subtitle">
                Visão de Lotes
              </h3>
            </div>
          </div>

          <div style={{ width: "100%", maxWidth: 400 }}>
            <Dropdown
              control={control}
              label={"Lotes"}
              name={"batches"}
              placeholderText={"Selecione..."}
              noOptionsMessage={() => "Nenhuma opção disponível"}
              options={batches?.filter((batch) => batch.status === "ACTIVE")
                .map((batch) => ({
                  value: batch.id,
                  label: `${batch.farm.initials}-${batch.area.initials}-${batch.initials}`,
                }))
                .sort(sortBy("label")) || []}
              isMulti
            />

            <div style={{ display: "flex", gap: 10 }}>
              <ButtonExportPDF />
              {batchCategory && batchCategory.content && batchCategory.content.length > 0 && (
                <ButtonExportExcel
                  onClick={() => {
                    try {
                      exportBatchesDataToExcel(batchCategory);
                    } catch (error) {
                      console.error('Erro ao exportar:', error);
                      alert('Erro ao exportar dados. Tente novamente.');
                    }
                  }}
                />
              )}
            </div>
          </div>

          <div className="tableDashboard">
            <table>
              <thead style={{
                color: "#fff"
              }}>
                <th scope="col" rowSpan={2} style={{
                  background: "#324440",
                  width: "150px",
                  textAlign: "left"
                }}>
                  Lotes
                </th>
                <th scope="col" colSpan={6} style={{
                  textAlign: "center",
                  background: "#62b8ae"
                }}>
                  Macho
                </th>
                <th scope="col" colSpan={5} style={{
                  textAlign: "center",
                  background: "#ff6161"
                }}>
                  Fêmea
                </th>
                <th scope="col" rowSpan={2} style={{
                  background: "#57CE71",
                  width: "80px"
                }}>
                  Saldo
                </th>
                <tr>
                  <th scope="col" style={{
                    background: "#324440",
                    width: "80px"
                  }}>
                    0 a 8 meses
                  </th>
                  <th scope="col" style={{
                    background: "#324440",
                    width: "80px"
                  }}>
                    9 a 12 meses
                  </th>
                  <th scope="col" style={{
                    background: "#324440",
                    width: "80px"
                  }}>
                    13 a 24 meses
                  </th>
                  <th scope="col" style={{
                    background: "#324440",
                    width: "80px"
                  }}>
                    25 a 36 meses
                  </th>
                  <th scope="col" style={{
                    background: "#324440",
                    width: "80px"
                  }}>
                    {`> 37 meses`}
                  </th>
                  <th scope="col" style={{
                    background: "#324440",
                    width: "80px"
                  }}>
                    Touros
                  </th>
                  <th scope="col" style={{
                    background: "#324440",
                    width: "80px"
                  }}>
                    0 a 8 meses
                  </th>
                  <th scope="col" style={{
                    background: "#324440",
                    width: "80px"
                  }}>
                    9 a 12 meses
                  </th>
                  <th scope="col" style={{
                    background: "#324440",
                    width: "80px"
                  }}>
                    13 a 24 meses
                  </th>
                  <th scope="col" style={{
                    background: "#324440",
                    width: "80px"
                  }}>
                    25 a 36 meses
                  </th>
                  <th scope="col" style={{
                    background: "#324440",
                    width: "80px"
                  }}>
                    {`> 37 meses`}
                  </th>
                </tr>
              </thead>

              <tbody>
                {batchCategory && batchCategory.content.map((batch, index) => (
                  <tr className={index % 2 === 0 ? " bg_white" : "bg_gray"}>
                    <th scope="row">{`${batch.farm_initials}-${batch.area_initials}-${batch.initials}`}</th>
                    {[6, 7, 8, 9, 10, 11].map((id) => (
                      <td key={`male-${id}`}>
                        {batch.categories.find((category) => category.id === id)?.quantity || 0}
                      </td>
                    ))}
                    {[1, 2, 3, 4, 5].map((id) => (
                      <td key={`female-${id}`}>
                        {batch.categories.find((category) => category.id === id)?.quantity || 0}
                      </td>
                    ))}
                    <td>
                      {batch.categories.reduce((sum, category) => sum + category.quantity, 0)}
                    </td>
                  </tr>
                ))}
              </tbody>

              <tfoot
                style={{
                  background: "#324440",
                  color: "#fff"
                }}
              >
                <th style={{
                  textAlign: "left"
                }}>Total</th>
                {[6, 7, 8, 9, 10, 11].map((id) => (
                  <td key={`male-${id}`}>
                    {batchCategory
                      ? batchCategory.content.reduce(
                        (sum, batch) =>
                          sum +
                          (batch.categories.find((category) => category.id === id)?.quantity || 0),
                        0
                      )
                      : 0}
                  </td>
                ))}
                {[1, 2, 3, 4, 5].map((id) => (
                  <td key={`female-${id}`}>
                    {batchCategory
                      ? batchCategory.content.reduce(
                        (sum, batch) =>
                          sum +
                          (batch.categories.find((category) => category.id === id)?.quantity || 0),
                        0
                      )
                      : 0}
                  </td>
                ))}
                <td>
                  {batchCategory
                    ? batchCategory.content.reduce(
                      (sum, batch) =>
                        sum +
                        batch.categories.reduce((batchSum, category) => batchSum + category.quantity, 0),
                      0
                    )
                    : 0}
                </td>
              </tfoot>
            </table>
          </div>
        </div>
      </form>
    </div>
  );
}
